import { MetadataPutEnum } from "@models/enums/metadata-put-enum";

export abstract class FormBase {
  entNrId?: number;
  entTxMetadado?: MetadataPutEnum;
}

export interface ControlFormGroupBuilder {}

